import { render, staticRenderFns } from "./wcyg-section.vue?vue&type=template&id=5d1d4045&scoped=true"
import script from "./wcyg-section.vue?vue&type=script&lang=ts"
export * from "./wcyg-section.vue?vue&type=script&lang=ts"
import style0 from "./wcyg-section.vue?vue&type=style&index=0&id=5d1d4045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d4045",
  null
  
)

export default component.exports